// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage  } from "firebase/storage"; 
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAuth } from "firebase/auth";


//  Firebase config object
const firebaseConfig = {
  databaseURL: "YOUR_DATABASE_URL",
  apiKey: "AIzaSyD0FsJISDkxLw_feekkO7ZuXvLs8NVTJxM",
  authDomain: "demosharingproject.firebaseapp.com",
  projectId: "demosharingproject",
  storageBucket: "demosharingproject.appspot.com",
  messagingSenderId: "34903383064",
  appId: "1:34903383064:web:d967cedcb3f784c43db76d",
};
// Initialize Firebase App

const app = initializeApp(firebaseConfig); // Ensures app is initialized

// Export Firebase services
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);  

// Connect to emulator if in development mode
if (process.env.NODE_ENV === "development") {
  connectFunctionsEmulator(functions, "localhost", 5001);
 
}

